// extracted by mini-css-extract-plugin
module.exports = {"addon":"addons-module--addon--1RBXl","addonCentered":"addons-module--addon--centered--1ASYn"};